<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div class="wy-exp-and-auto-header-popup right">
    <el-dropdown ref="configureDropdown" trigger="click" @visible-change="handleChangeVisible">
      <el-tooltip ref="configureTooltip" content="Configure" placement="bottom">
        <el-button @click="handleConfitureTooltip" class="setting-icon" plain>
          <img class="setting-img" src="../../assets/icons/icon_setting.svg" alt="setting icon" />
          <i class="el-icon-arrow-down esetting-icon l-icon--right setting-arrow-down"></i>
        </el-button>
      </el-tooltip>
      <el-dropdown-menu slot="dropdown" class="wy-home-header-setting">
        <div class="gear-panel" v-if="controller">
          <div class="gear-header">
            Configure
            <img @click="handleCloseDropdown" class="close-img" src="../../assets/icons/icon_customer_close.svg" alt="close configure dropdown icon" />
          </div>
          <div class="gear-flex">
            Date period:
            <div class="home-gear-top">
              <div class="home-dashboard performance-compare-group-by">
                <el-select
                  v-model="localSelecteddatePeriodRange"
                  collapse-tags
                  size="mini"
                  style="margin-left: 5px;"
                  class="date-range-dropdown"
                  :class="firstDropdownOepn ? 'blue-border' : ''"
                  @visible-change="handleSelected($event, 'firstDropdown')"
                  popper-class="table-filter-dropdown date-range"
                  :popper-append-to-body="false"
                  @change="handleTypeChange"
                >
                  <el-option v-for="item in datePeriodTypes" :disabled="item.disabled" :key="item.type" :label="item.label" :value="item.label"> </el-option>
                </el-select>
              </div>
            </div>
          </div>

          <div v-if="showChartViewBy" class="gear-flex">
            Chart:
            <div class="home-gear-top">
              <div class="performance-compare-group-by">
                <el-select
                  v-model="selectedDateRange"
                  collapse-tags
                  size="mini"
                  :class="secondDropdownOepn ? 'blue-border' : ''"
                  style="margin-left: 5px;"
                  class="date-range-dropdown"
                  @visible-change="handleSelected($event, 'secondDropdown')"
                  popper-class="table-filter-dropdown date-range"
                  :popper-append-to-body="false"
                  @change="dateRangeChanged(selectedDateRange)"
                >
                  <el-option v-for="item in dateRangeTypes" :disabled="item.disabled" :key="item.type" :label="item.label" :value="item.type"> </el-option>
                </el-select>
              </div>
            </div>
          </div>
        </div>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import Vue from 'vue';
import moment from 'moment';
import { mapGetters } from 'vuex';

export default Vue.extend({
  name: 'wy-exp-and-auto-header-popup',
  props: ['controller', 'showChartViewBy', 'panelTitleNoBracket', 'graphType', 'selecteddatePeriodRange'],

  data() {
    return {
      isApplied: false,
      temDateRange: 'day',
      tempBuckets: {},
      firstDropdownOepn: false,
      secondDropdownOepn: false,
      localSelecteddatePeriodRange: this.selecteddatePeriodRange.charAt(0).toUpperCase() + this.selecteddatePeriodRange.slice(1),
      selectedDateRange: 'month',
      datePeriodTypes: {
        last7days: {
          type: 'last7days',
          label: 'Last 7 days',
          tickformat: '%b %d %Y',
          disabled: false,
        },
        last30days: {
          type: 'last30days',
          label: 'Last 30 days',
          tickformat: '%b %d %Y',
          disabled: false,
        },
        last3months: {
          type: 'last3months',
          label: 'Last 3 months',
          tickformat: '%b %Y',
          disabled: false,
        },
      },
      dateRangeTypes: {
        year: {
          type: 'year',
          label: 'View by year',
          tickformat: '%Y',
          disabled: true,
          duraion: 99999,
        },
        month: {
          type: 'month',
          label: 'View by month',
          tickformat: '%b %Y',
          disabled: true,
          duraion: 365,
        },
        week: {
          type: 'week',
          label: 'View by week',
          tickformat: '%b %d %Y',
          disabled: true,
          duraion: 30,
        },
        day: {
          type: 'day',
          label: 'View by day',
          tickformat: '%b %d %Y',
          disabled: true,
          duraion: 7,
        },
      },
    };
  },

  watch: {
    'controller.dataIndex': {
      immediate: false,
      handler() {
        // console.log("tab changed.....")
        // this.checkDailyOption();
      },
    },

    'controller.sectionData': {
      immediate: false,
      handler() {
        // console.log("sectionData changed.....")
        // this.checkDailyOption();
      },
    },
    'dataModel.dateEnd': {
      immediate: true,
      handler() {
        // console.log("date range changed....")
        // this.checkDailyOption();
      },
    },
  },

  computed: {
    ...mapGetters(['dataModel']),
  },

  methods: {
    handleChangeVisible(isOpen) {
      if (isOpen) {
        this.isApplied = false;
        this.temDateRange = this.selectedDateRange;
      } else {
        if (this.isApplied) {
          this.isApplied = false;
        }
      }
    },
    handleCloseGearPopup() {
      if (document.querySelector('.table-filter-dropdown')) document.querySelector('.table-filter-dropdown').blur();
    },
    handleHidePopper(isScroll) {
      if (isScroll && this.$refs.configureDropdown) {
        this.$refs.configureDropdown.hide();
      }
    },
    handleConfitureTooltip() {
      if (this.$refs.configureTooltip) this.$refs.configureTooltip.hide();
    },
    formatDate(inputDate) {
      var date = new Date(inputDate);

      var year = date.toLocaleString('default', { year: 'numeric' });
      var month = date.toLocaleString('default', { month: '2-digit' });
      var day = date.toLocaleString('default', { day: '2-digit' });

      return year + '-' + month + '-' + day;
    },
    handleTypeChange(type) {
      let startDate = '';
      let endDate = '';
      if (type == 'Last 7 days') {
        let date = new Date();
        startDate = this.formatDate(new Date());
        endDate = this.formatDate(date.setDate(date.getDate() - 6));
        this.dateRangeTypes.week.disabled = true;
        this.dateRangeTypes.month.disabled = true;
        this.dateRangeTypes.day.disabled = false;
        this.controller.dateRange = 'day';
        this.selectedDateRange = 'day';
      } else if (type == 'Last 30 days') {
        let date = new Date();
        startDate = this.formatDate(new Date());
        endDate = this.formatDate(date.setDate(date.getDate() - 29));
        this.dateRangeTypes.month.disabled = true;
        this.dateRangeTypes.week.disabled = false;
        this.dateRangeTypes.day.disabled = false;
        this.controller.dateRange = 'day';
        this.selectedDateRange = 'day';
      } else if (type == 'Last 3 months') {
        let date = new Date();
        startDate = this.formatDate(new Date());
        endDate = this.formatDate(date.setDate(date.getDate() - 89));
        this.dateRangeTypes.week.disabled = false;
        this.dateRangeTypes.day.disabled = false;
        this.dateRangeTypes.month.disabled = false;
        this.controller.dateRange = 'week';
        this.selectedDateRange = 'week';
      }
      this.controller.changeDatePeriod(startDate, endDate, type);
    },

    handleApply() {
      this.$refs.configureDropdown.hide();
      this.controller.changeDateRange(this.selectedDateRange);
      this.isApplied = true;
      // this.handleCloseDropdown()
      this.$root.$emit(`fire-selected-date-change-events`, this.selectedDateRange);
    },
    dateRangeChanged(selectedDateRange) {
      if (!this.controller.pannelData.filterSettings || this.controller.overviewData) {
        this.controller.changeDateRange(selectedDateRange);
      }
    },
    handleSelected(isOpen, dropdown) {
      if (this.controller.pannelData) {
        if (!isOpen && !this.controller.pannelData.filterSettings) {
          this.$refs.configureDropdown.hide();
          this.$root.$emit(`fire-selected-date-change-events`, this.selectedDateRange);

          this.firstDropdownOepn = false;
          this.secondDropdownOepn = false;
        } else {
          if (dropdown == 'firstDropdown') {
            this.firstDropdownOepn = true;
          } else if (dropdown == 'secondDropdown') {
            this.secondDropdownOepn = true;
          }
        }
      } else {
        if (!isOpen && this.controller.overviewData) {
          this.$refs.configureDropdown.hide();
          this.$root.$emit(`fire-selected-date-change-events`, this.selectedDateRange);

          this.firstDropdownOepn = false;
          this.secondDropdownOepn = false;
        } else {
          if (dropdown == 'firstDropdown') {
            this.firstDropdownOepn = true;
          } else if (dropdown == 'secondDropdown') {
            this.secondDropdownOepn = true;
          }
        }
      }
    },
    handleCloseDropdown() {
      this.$refs.configureDropdown.hide();
    },
    checkDailyOption() {
      let dateStartMoment = moment(this.dataModel.dateStart, 'YYYY-MM-DD');
      let dateEndMoment = moment(this.dataModel.dateEnd, 'YYYY-MM-DD');
      this.dateRangeDatesDiff = dateEndMoment.diff(dateStartMoment, 'days', true);
      // console.log("this.dateRangeDatesDiff > 30", this.dateRangeDatesDiff > 30, this.dateRangeTypes, this.controller.sectionData.columnChartData)
      if (this.dateRangeDatesDiff + 1 > 60 && this.controller.sectionData && this.controller.sectionData.columnChartData) {
        this.dateRangeTypes.day.disabled = true;
        // console.log(this.selectedDateRange)
        if (this.selectedDateRange == 'day') {
          this.selectedDateRange = 'week';
          this.dateRangeChanged(this.selectedDateRange);
        }
      } else {
        this.dateRangeTypes.day.disabled = false;
      }
    },
    getDisabled(item) {
      if (this.dataModel.dateStart && this.dataModel.dateStart) {
        let dateStartMoment = moment(this.dataModel.dateStart, 'YYYY-MM-DD');
        let dateEndMoment = moment(this.dataModel.dateEnd, 'YYYY-MM-DD');
        this.dateRangeDatesDiff = dateEndMoment.diff(dateStartMoment, 'days', true);
        // console.log(this.controller, item.type)
        if (this.dateRangeDatesDiff > 30 && item.type == 'day') {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
      // return false
    },

    handlePopperHide() {
      this.$refs.configureDropdown.hide();
    },
  },
  destroyed() {
    window.removeEventListener('resize', this.handlePopperHide);
  },
  mounted() {
    this.$root.$on(`fire-app-hide-popper-events`, (isScroll) => {
      this.handleHidePopper(isScroll);
    });
    this.selectedDateRange = this.controller.dateRange;

    window.addEventListener('resize', this.handlePopperHide);
    if (this.localSelecteddatePeriodRange == 'Last 7 days') {
      this.dateRangeTypes.week.disabled = true;
      this.dateRangeTypes.month.disabled = true;
      this.dateRangeTypes.day.disabled = false;
    } else if (this.localSelecteddatePeriodRange == 'Last 30 days') {
      this.dateRangeTypes.month.disabled = true;
      this.dateRangeTypes.week.disabled = false;
      this.dateRangeTypes.day.disabled = false;
    } else if (this.localSelecteddatePeriodRange == 'Last 3 months') {
      this.dateRangeTypes.week.disabled = false;
      this.dateRangeTypes.day.disabled = false;
      this.dateRangeTypes.month.disabled = false;
    }

    if (document.querySelector('.wy-container-main ')) {
      document.querySelector('.wy-container-main ').addEventListener('scroll', this.handleCloseGearPopup);
    }
  },
});
</script>

<style lang="scss">
button.el-button.gear-dropdowns.el-button--default.is-plain.el-dropdown-selfdefine {
  border-radius: 5px;
  margin: 10px;
  padding: 5px;
}
.home-dashboard,
.performance-compare-group-by {
  .el-input__suffix {
    right: 0px;
  }
}
.performance-compare-group-by {
  .el-select.date-range-dropdown.el-select--mini {
    width: 7.86vw !important;
    min-width: 128px;
    border: 1px #dcdfe6 solid;
    border-radius: 5px;
    position: relative;
    right: 0.24vw;
  }
  .el-select.date-range-dropdown.el-select--mini.blue-border {
    border: 1px #106fbc solid;
  }
  .el-select.date-range-dropdown.el-select--mini:active {
    border: 1px solid #1c4db2;
  }
  input.el-input__inner {
    border-width: 0px 0px 1px 0px !important;
    border-radius: 5px;
    padding-left: 5px;
  }
  .el-input__inner {
    border: 1px solid transparent !important;
    &:hover {
      background: #f4f6f8;
    }
  }
}

.buckets-section {
  .el-input-number--mini {
    width: 97px !important;
    margin-top: 10px !important;
    line-height: 26px !important;
  }
  .gear-middle {
    margin-left: 20px !important;
  }
  .index {
    color: #828e9a;
    font-size: 12px !important;
    position: relative;
    right: 7px;
    font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif !important;
  }
  .sub-headers {
    font-weight: 500 !important;
    font-size: 14px !important;
    font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif !important;
    margin-top: 15px !important;
    margin-bottom: 5px !important;
  }
  .garbage-can-img {
    margin-left: 9px !important;
    cursor: pointer;
    &:hover {
      background: #f4f6f8;
    }
  }
  .add-fiter.gear-row {
    margin-top: 10px !important;
    margin-left: 0px !important;
    font-size: 12px !important;
  }
  .dash {
    color: #cad2da !important;
    margin-left: 2px !important;
    margin-right: 2px !important;
  }
  .plus {
    position: relative;
    right: 54px;
    bottom: 1px;
    margin-left: 2px !important;
    margin-right: 2px !important;
    font-size: 14px;
    color: var(--site-font-secondary-color);
  }
}
.wy-exp-and-auto-header-popup {
  position: relative;
  left: 20px;
  .gear-middle,
  .gear-bottom {
    margin-top: 20px;
    padding: 5px 20px;
  }
  .sub-headers {
    font-weight: 500;
    font-size: 14px;
  }
  .gear-bottom {
    padding-bottom: 15px;
  }

  .gear-panel {
    background: #ffffff;
    border: 1px solid #cad2da !important;
    box-sizing: border-box;
    border-radius: 10px;
    margin-top: -15px;
    margin-bottom: -15px;
  }

  .setting-icon {
    padding: 0px 3px 8px 7px;
    position: relative;
    // top: 6px;
    // bottom: 10px;
  }
  .bookmark-img {
    position: relative;
    bottom: 7px;
    width: 15px;
    user-select: none !important;
    margin-right: 15px;
  }
  .setting-img {
    position: relative;
    user-select: none !important;
    right: 1px;
    width: 18px;
    top: 0vw !important;
    &:active {
      background: #e8f1ff;
      color: #1c4db2;
    }
  }
}

.handling-time-header-settig {
  height: 444px;
  overflow: hidden hidden;
  .gear-panel {
    // overflow: hidden scroll;
    height: 400px;
    .gear-flex {
      height: 356px;
      overflow: hidden scroll;
    }
  }
}
.wy-home-header-setting {
  .gear-flex {
    padding: 19px;
    color: #000000;
    font-size: 14.22px;
  }
  .home-gear-top {
    display: flex !important;
    align-items: center;
    padding: 10px 20px 0px 0px;
    font-weight: 400;
    font-size: 14.22px;

    .el-icon-arrow-up:before {
      content: '\E6E1';
      color: #828e9a;
      font-size: 10px;
      font-weight: 600;
    }

    .table-filter-dropdown .el-select-dropdown__item {
      height: 29px;
      line-height: 33px;
      font-weight: normal;
      font-size: 14px;
      padding: 0 10px;
      margin: 2px 0px 0px 0px !important;
      &:hover {
        background: #f4f6f8 !important;
      }
      &:active {
        background: #e8f1ff !important;
        color: #1c4db2;
      }
    }
    .table-filter-dropdown .el-select-dropdown__item.selected {
      border: none;
      background-image: none !important;
      background: #e8f1ff !important;
      color: #1c4db2;
    }
  }

  .gear-panel {
    margin-bottom: 0px;
    width: 274px;
    // height: 80px;
  }
  .el-input__inner {
    font-family: 'Helvetica Neue', Helvetica !important;
    border-radius: 5px;
    padding: 8px 12px;
    font-size: 14.22px;
    font-family: Helvetica Neue, Helvetica;
    color: var(--site-font-secondary-color);
    font-weight: normal;
    &:hover {
      background: #f4f6f8;
    }
  }
  .gear-header {
    border-bottom: 1px solid #cad2da;
    margin-bottom: 0px;
    padding: 14px 12px 12px 20px !important;
    font-weight: 500;
    font-size: 14.22px;
  }

  .add-filter-img {
    position: relative;
    margin-right: 5px;
    user-select: none !important;
    width: 11px;
    cursor: pointer;
    &:hover {
      background: #f4f6f8;
    }
  }
  .close-img {
    width: 10px;
    cursor: pointer;
    user-select: none !important;
    float: right;
    position: relative;
    top: -10px;
    &:hover {
      background: #f4f6f8;
    }
  }
  .gear-row {
    width: 300px;
  }
  .add-fiter.gear-row {
    font-size: 12px !important;
    display: flex;
  }
  .apply-div {
    height: 44px;
    border-top: 0.5px solid #cad2da;
    padding-top: 6px;
    .apply-btn,
    .reset-btn,
    .cancel-btn {
      position: relative;
      bottom: -6px;
      right: 27px;
      // right: 174px;
      font-size: 14px;
      color: var(site-font-chart-color);
      width: 55px;
      height: 30px;
      border-radius: 4px;
      padding: 0px;
      float: right;
      .char {
        margin-left: auto;
        color: #d2d2d2;
      }
      .apply-text {
        position: relative;
        // right: 21px;
        font-weight: normal;
        font-size: 14px;
      }
    }
    .reset-btn {
      float: left;
      left: 8px;
      border: 0px;
      color: #1c4db2;
    }
    .cancel-btn {
      float: left;
      left: 5px;
      border: 0px;
      color: #1c4db2;
    }
    .reset-btn:hover {
      border-color: #1c4db2 !important;
      color: #1c4db2 !important;
      text-decoration: underline;
    }
    .cancel-btn:hover {
      border-color: #1c4db2 !important;
      color: #1c4db2 !important;
      // text-decoration: underline;
    }
    .el-button.is-plain:focus,
    .el-button.is-plain:hover {
      border-color: #606266;
      color: #606266;
    }
  }
}
</style>
